// API Configuration
// This file contains the configuration for the API endpoints
// It uses environment variables to determine the base URL based on the current environment

type Endpoint = 'todos' | 'websocket' | 'auth';

// Define the base URL for the API
// In development, use the local API
// In production, use the production API
// This can be overridden by setting the VITE_API_BASE_URL environment variable
export const API_CONFIG = {
  baseUrl: 'https://todo-7j2j.onrender.com',
  endpoints: {
    todos: '/todos',
    websocket: '/websocket',
    auth: '/auth',
  } satisfies Record<Endpoint, string>,
  // Per-endpoint base URL override, e.g. the websocket worker is a separate Render service
  baseUrls: {
    websocket: 'https://todo-worker.onrender.com',
  } as Partial<Record<Endpoint, string>>,
};
const prefixUrl = 'api';

// Helper function to get the full URL for an endpoint
export function getApiUrl(endpoint: Endpoint, id?: number): string {
  const baseUrl = API_CONFIG.baseUrls[endpoint] ?? API_CONFIG.baseUrl;
  const path = API_CONFIG.endpoints[endpoint];
  
  const url = `${baseUrl}/${prefixUrl}${path}`;
  
  if (id !== undefined) {
    return `${url}/${id}`;
  }
  
  return url;
}